"use strict";
var logo = document.querySelector(".logo");
var promise1 = new Promise(function(resolve, reject) {
    logo.addEventListener("click", function() {
        resolve();
    });
});
var promise2 = new Promise(function(resolve, reject) {
    Promise.resolve().then(function() {
        setTimeout(function() {
            reject(new Error("Promise rejected"));
        }, 3000);
    });
});
promise1.then(function() {
    var div = document.createElement("div");
    div.classList.add("message");
    div.textContent = "Promise was resolved!";
    document.body.appendChild(div);
}).catch(function() {
    var div = document.createElement("div");
    div.classList.add("message error-message");
    div.textContent = "Promise was rejected!";
    document.body.appendChild(div);
});
promise2.then(function() {
    var div = document.createElement("div");
    div.classList.add("message");
    div.textContent = "Promise was resolved!";
    document.body.appendChild(div);
}).catch(function() {
    var div = document.createElement("div");
    div.classList.add("message");
    div.classList.add("error-message");
    div.textContent = "Promise was rejected!";
    document.body.appendChild(div);
});

//# sourceMappingURL=index.f7a82412.js.map
